import { useState } from 'react';
import { subscription } from '@/mocks/subscription';

export default function AbonelikPage() {
  const [activeTab, setActiveTab] = useState<'status' | 'history'>('status');

  const statusColor = subscription.panelUsageStatus === 'Aktif' ? '#10B981' : subscription.panelUsageStatus === 'Uyarıda' ? '#F59E0B' : '#EF4444';
  const paymentColor = subscription.monthlyPaymentStatus === 'Yapıldı' ? '#10B981' : '#F59E0B';

  return (
    <div className="space-y-4 animate-fade-in">
      <div>
        <h1 className="text-xl md:text-2xl font-bold font-display" style={{ color: 'var(--text-primary)' }}>Abonelik Durumu</h1>
        <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>Kuğu Spa panel kullanım bilgileri</p>
      </div>

      {/* Main Status Card */}
      <div className="spa-card p-6 space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: statusColor + '15' }}>
            <i className="ri-shield-check-line text-2xl" style={{ color: statusColor }} />
          </div>
          <div>
            <div className="flex items-center gap-3">
              <h2 className="text-lg font-semibold font-display" style={{ color: 'var(--text-primary)' }}>Panel Kullanım Durumu</h2>
              <span className="spa-badge" style={{ background: statusColor + '15', color: statusColor }}>
                {subscription.panelUsageStatus}
              </span>
            </div>
            <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
              {subscription.panelUsageStatus === 'Aktif'
                ? 'Bu ay panel kullanımınız aktiftir.'
                : subscription.panelUsageStatus === 'Uyarıda'
                ? 'Bu ay hizmet ödemeniz beklemede görünüyor. Panel kullanımınızın kesintisiz devam etmesi için danışmanınızla iletişime geçebilirsiniz.'
                : 'Panel kullanımınız geçici olarak pasif durumdadır. Detaylı bilgi için destek ekibiyle iletişime geçiniz.'}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Hizmet Dönemi</p>
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{subscription.servicePeriod}</p>
          </div>

          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-money-cny-circle-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Aylık Ödeme Durumu</p>
            </div>
            <span className="spa-badge" style={{ background: paymentColor + '15', color: paymentColor }}>
              {subscription.monthlyPaymentStatus}
            </span>
          </div>

          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-time-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Son Kontrol</p>
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{subscription.lastCheckDate}</p>
          </div>

          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-check-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Kullanım Bitiş</p>
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{subscription.usageExpiryDate}</p>
          </div>

          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-phone-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Destek İletişim</p>
            </div>
            <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{subscription.supportContact}</p>
          </div>

          <div className="p-4 rounded-spa-sm space-y-2" style={{ background: 'var(--bg-tertiary)' }}>
            <div className="flex items-center gap-2">
              <i className="ri-notification-3-line" style={{ color: subscription.paymentReminder ? '#EF4444' : 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Ödeme Hatırlatma</p>
            </div>
            <span className="spa-badge text-[10px]" style={{ background: subscription.paymentReminder ? 'rgba(239,68,68,0.12)' : 'rgba(16,185,129,0.12)', color: subscription.paymentReminder ? '#EF4444' : '#10B981' }}>
              {subscription.paymentReminder ? 'Bekliyor' : 'Yok'}
            </span>
          </div>
        </div>

        {/* Admin Note */}
        {subscription.adminNote && (
          <div className="p-4 rounded-spa-sm" style={{ background: 'rgba(201,169,98,0.06)', border: '1px solid rgba(201,169,98,0.15)' }}>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-file-list-3-line" style={{ color: 'var(--gold)' }} />
              <p className="text-xs font-medium" style={{ color: 'var(--gold)' }}>Yönetici Notu</p>
            </div>
            <p className="text-sm" style={{ color: 'var(--text-primary)' }}>{subscription.adminNote}</p>
          </div>
        )}
      </div>

      {/* Contact Info */}
      <div className="spa-card p-4">
        <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>İşletme Bilgileri</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          <div className="p-3 rounded-spa-sm" style={{ background: 'var(--bg-tertiary)' }}>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Salon Adı</p>
            <p style={{ color: 'var(--text-primary)' }}>{subscription.salonName}</p>
          </div>
          <div className="p-3 rounded-spa-sm" style={{ background: 'var(--bg-tertiary)' }}>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Yetkili Kişi</p>
            <p style={{ color: 'var(--text-primary)' }}>{subscription.contactPerson}</p>
          </div>
          <div className="p-3 rounded-spa-sm" style={{ background: 'var(--bg-tertiary)' }}>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Telefon</p>
            <p style={{ color: 'var(--text-primary)' }}>{subscription.contactPhone}</p>
          </div>
          <div className="p-3 rounded-spa-sm" style={{ background: 'var(--bg-tertiary)' }}>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>E-posta</p>
            <p style={{ color: 'var(--text-primary)' }}>{subscription.contactEmail}</p>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="p-4 rounded-spa-sm text-xs text-center" style={{ background: 'var(--bg-tertiary)', color: 'var(--text-muted)' }}>
        <i className="ri-information-line mr-1" />
        Abonelik durumu bilgilendirme amaçlıdır. Fiyat ve ödeme detayları için danışmanınızla iletişime geçiniz.
      </div>
    </div>
  );
}